module.exports = __webpack_public_path__ + "static/media/path-295-at-1x.d1b72748.webp";